import * as React from "react";
import Grid from "../grid/grid";
import GridItem from "../grid/griditem";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const revoTitleClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    minHeight: "72px",
    paddingLeft: "24px",
    paddingRight: "24px",
    whiteSpace: "nowrap",
});
const titleClass = css({
    color: getThemeColorVar("typo", "dark"),
    fontSize: "24px",
    lineHeight: "24px",
    fontWeight: "bold",
    minHeight: "24px",
});
export const RevoTitle = (props) => {
    const { title } = props;
    return (React.createElement("div", { className: cx(revoTitleClass) },
        React.createElement(Grid, { columns: 1, height: [72, "px"] },
            React.createElement(GridItem, { alignSelf: "center" },
                React.createElement("div", { className: cx(titleClass) }, title)))));
};
export default RevoTitle;
//# sourceMappingURL=revo-title.js.map